export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'success',
          text: 'Nuevo'
        }
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Aula Virtual',
        route: '/actividades',
        icon: 'cil-cursor',
        items: [
          {
            name: 'Gestión de Actividades',
            to: '/actividades/gestionactividades'
          },
          {
            name: 'Revisar Tareas',
            to: '/actividades/revisartareas'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Horario de Clases',
        to: '/horarios/horarioclases',
        icon: 'cil-calendar'
      }
    ]
  }
]